var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 46,
    viewBox: "0 0 37 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1751 41.8C10.3591 41.8 4 35.8109 4 28.4493C4 18.175 18.1752 4 18.1752 4C18.1752 4 32.35 18.175 32.35 28.4493C32.35 35.811 25.9911 41.8 18.1751 41.8Z",
    fill: "#20E89C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2616 27.625C24.2067 30.9254 21.5555 33.5644 18.1741 34.7125",
    stroke: "#060606",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_193_10353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1751 41.8C10.3591 41.8 4 35.8109 4 28.4493C4 18.175 18.1752 4 18.1752 4C18.1752 4 32.35 18.175 32.35 28.4493C32.35 35.811 25.9911 41.8 18.1751 41.8Z",
    fill: "#20E89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2616 27.625C24.2067 30.9254 21.5555 33.5644 18.1741 34.7125",
    stroke: "#060606",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_193_10353",
    x: 0,
    y: 0,
    width: 36.35,
    height: 45.7998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_193_10353"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityIcon);
export default __webpack_public_path__ + "static/media/humidityIcon.de2c5cc8e0aa30bf5bbe440f911f4ce8.svg";
export { ForwardRef as ReactComponent };